// import React, { useState } from 'react';

// const URLTOOLS = () => {
//   const [urls, setUrls] = useState('');
//   const [openInNewTab, setOpenInNewTab] = useState(true);

//   const handleUrlsChange = (e) => {
//     setUrls(e.target.value);
//   };

//   const handleOpenInNewTabChange = (e) => {
//     setOpenInNewTab(e.target.checked);
//   };

//   const handleOpenUrls = () => {
//     const urlList = urls.split('\n').filter(Boolean); // Filter out empty lines
//     urlList.forEach((url) => {
//       if (openInNewTab) {
//         window.open(url, '_blank');
//       } else {
//         window.open(url, '_self');
//       }
//     });
//   };

//   return (
//     <div className="container mt-5 p-4 bg-white rounded shadow">
//         <div className="card-body">
//           <div className="mb-3">
//             <textarea
//               className="form-control"
//               rows="8"
//               value={urls}
//               onChange={handleUrlsChange}
//               placeholder="Enter multiple URLs, one per line"
//             />
//           </div>

//           <div className="form-check mb-3">
//             <input
//               type="checkbox"
//               className="form-check-input"
//               id="newTabCheck"
//               checked={openInNewTab}
//               onChange={handleOpenInNewTabChange}
//             />
//             <label className="form-check-label" htmlFor="newTabCheck">
//             Open in new tab
//             </label>
//           </div>

//           <button
//             className="btn btn-primary w-100"
//             onClick={handleOpenUrls}
//           >
//             Open URLs
//           </button>
//         </div>
      
//     </div>
//   );
// };

// export default URLTOOLS;
import React, { useState } from 'react';

const URLTOOLS = () => {
  const [urls, setUrls] = useState('');
  const [openInNewTab, setOpenInNewTab] = useState(true);

  const handleUrlsChange = (e) => {
    setUrls(e.target.value);
  };

  const handleOpenInNewTabChange = (e) => {
    setOpenInNewTab(e.target.checked);
  };

  const openSingleUrl = (url) => {
    const formattedUrl = url.startsWith('http') ? url : `https://${url}`; // Ensure URL starts with http/https
    if (openInNewTab) {
      window.open(formattedUrl, '_blank');
    } else {
      window.open(formattedUrl, '_self');
    }
  };

  const handleClear = () => {
    setUrls('');
    setOpenInNewTab('');
  };


  const openAllUrls = () => {
    const urlList = urls.split('\n').filter(Boolean); // Filter out empty lines
    urlList.forEach((url) => openSingleUrl(url));
  };

  const urlList = urls.split('\n').filter(Boolean); // Filter out empty lines

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <div className="card-body">

        {/* Textarea Input */}
        <div className="mb-3">
          <textarea
            className="form-control"
            rows="8"
            value={urls}
            onChange={handleUrlsChange}
            placeholder="Enter multiple URLs, one per line"
          />
        </div>

        {/* Checkbox for New Tab */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="newTabCheck"
            checked={openInNewTab}
            onChange={handleOpenInNewTabChange}
          />
          <label className="form-check-label" htmlFor="newTabCheck">
            Open in new tab
          </label>
        </div>

        {/* Open All URLs Button */}
        <button
          className="btn btn-primary"
          onClick={openAllUrls}
          disabled={urlList.length === 0}
        >
          Open All URLs
        </button>
        <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>

        {/* URL List with Individual Buttons */}
        {urlList.length > 0 && (
          <ul className="list-group">
            {urlList.map((url, index) => (
              <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                <span>{url}</span>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => openSingleUrl(url)}
                >
                  Open
                </button>
   
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default URLTOOLS;
